module.exports = __webpack_public_path__ + "static/img/homes-two.0505db8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/homes-two.png
// module id = w43B
// module chunks = 0